
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/ipl/points-table",
      function () {
        return require("private-next-pages/sports/ipl/points-table/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/ipl/points-table"])
      });
    }
  